import './SwitcherScreen.vars.css'

const responsiveStyles = {
  top: 'var(--switcher-screen-top)',
  right: 'var(--switcher-screen-right)'
}

export default responsiveStyles
